/* "Other" free-text option toggle for select/radio/checkbox form fields */

const OTHER_SENTINEL = '__other__';

// Show/hide a single "Other" text input based on whether its controlling
// select/radio/checkbox currently has the "__other__" choice selected.
function syncOtherInput(input) {
  const form = input.closest('form');
  if (!form) return;

  const fieldName = input.dataset.wpsOtherFor;
  const controls = form.querySelectorAll(
    `[name="submission[${fieldName}]"], [name="submission[${fieldName}][]"]`
  );

  let otherSelected = false;
  controls.forEach(ctrl => {
    if (ctrl.tagName === 'SELECT') {
      if (ctrl.value === OTHER_SENTINEL) otherSelected = true;
    } else if (ctrl.type === 'radio' || ctrl.type === 'checkbox') {
      if (ctrl.value === OTHER_SENTINEL && ctrl.checked) otherSelected = true;
    }
  });

  if (otherSelected) {
    input.classList.remove('hidden');
  } else {
    input.classList.add('hidden');
    input.value = '';
  }
}

// Global delegated change listener — attached once at module load so it works
// regardless of when forms are rendered (Turbo navigations, Alpine, etc.).
document.addEventListener('change', (event) => {
  const name = event.target && event.target.name;
  if (!name || name.indexOf('submission[') !== 0) return;

  const form = event.target.closest('form');
  if (!form) return;

  form.querySelectorAll('[data-wps-other-input]').forEach(input => {
    const fieldName = input.dataset.wpsOtherFor;
    if (name === `submission[${fieldName}]` || name === `submission[${fieldName}][]`) {
      syncOtherInput(input);
    }
  });
});

// Sync initial visibility (e.g. when re-rendering after a validation error with
// a previously-selected "Other" value).
export function initFormOther() {
  document.querySelectorAll('[data-wps-other-input]').forEach(syncOtherInput);
}
